<footer class="footer">
    <div class="footer-container">

        <!-- Brand Section -->
        <div class="footer-col brand">
            <div class="logo">
                <img src="assets/images/logo.webp" loading="lazy" alt="Bhagyajit Herbal" height="166" width="512"/>
                <h2><span>BHAGYAJIT HERBAL</span></h2>
            </div>
            <div style="margin: 5px">
                <p class="tagline">Natural Skincare & Haircare Solutions</p>

                <p class="desc">
                    We create herbal organic skincare and haircare products using natural
                    ingredients to help you achieve healthy skin and beautiful hair.
                </p>
            </div>
            <h3>Social</h3>

            <div class="links">
                <ul>
                    <li><a href="https://wa.me/7020864796" target="_blank">
                        <fa-icon [icon]="faWhatsapp"></fa-icon>
                    </a></li>
                    <li>
                        <a href="https://www.instagram.com/bhagyajit_herbs_organic?igsh=eHQ3ZnVkYzhxOHZ5"
                           target="_blank"><fa-icon [icon]="faInstagram"></fa-icon></a>
                    </li>
                    <li class="info-item">
                        <a href="https://www.youtube.com/@bhagyajit0304"
                           target="_blank"><fa-icon [icon]="faYoutube"></fa-icon>
                        </a>

                    </li>
                    <li class="info-item"><a href="https://www.facebook.com/ajit.toradmal.52"
                                             target="_blank">
                        <fa-icon [icon]="faFacebook"></fa-icon></a>
                    </li>
                </ul>

            </div>
        </div>

        <!-- Quick Links -->
        <div class="footer-col">
            <h3>Quick Links</h3>
            <ul>
                <li style="color:white" routerLink="/home" routerLinkActive="active">Home |</li>
                <li style="color:white" routerLink="/about" routerLinkActive="active">About |</li>
                <li style="color:white" routerLink="/shop" routerLinkActive="active">Products |</li>
                <li style="color:white" routerLink="/shop"
                    [queryParams]="{  problem: 'a8fb0923-f0c7-47e3-b417-f2dd48320d14' }">Skin
                    Care |
                </li>
                <li style="color:white" routerLink="/shop"
                    [queryParams]="{  problem: '2910b720-c0d9-4e9c-a7ea-07054371d19e' }">Hair
                    Care |
                </li>
                <li style="color:white" routerLink="/shop"
                    [queryParams]="{ problem: 'b0054c90-05b2-4cb4-a726-72bd716a18cd' }">Body
                    Care |
                </li>
                <li style="color:white" routerLink="/contact" routerLinkActive="active">Contact Us</li>
            </ul>
        </div>

        <!-- Policy Links -->
        <div class="footer-col">
            <h3>Policies</h3>
            <a routerLink="/policy" routerLinkActive="active">
                <ul>
                    <li> Refund Policy |</li>
                    <li> Privacy Policy |</li>
                    <li>Shipping Policy |</li>
                    <li>Cancellation Policy |</li>
                    <li>Terms & Conditions</li>
                </ul>
            </a>
        </div>


        <!-- Features -->
        <div class="footer-col">
            <h3>Why Bhagyajit</h3>
            <div style="margin:5px">
                <span>✔ 100% Herbal organic Product</span> |
                <span>✔ Secure Payments</span> |
                <span>✔ Fast Delivery</span> |
                <span>✔ Customer Support</span> |
                <span>✔ UPI</span>
            </div>
        </div>

    </div>
    <!-- Copyright -->
    <div class="copyright">
        © 2026 Bhagyajit Herbal Private Limited. All Rights Reserved.
        <br/>
        Designed with ❤️ for Natural Beauty by <a href="https://api.whatsapp.com/send?phone=919503494813" style="color: dodgerblue;font-weight: bold;" target="_blank">WebSmith Solutions</a>
    </div>

</footer>